export default __webpack_public_path__ + "static/media/krud-kutter.7027d402.jpeg";